import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import { DropDownMultiCheck } from "../DropDownMultiCheck";

export default function YearsOFExperience(params) {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();
  const [yearsOfExperienceOptions, setYearsOfExperienceOptions] = useState([]);

  useEffect(
    () => CommonService.getAllYearsExperience().then((data) =>
        setYearsOfExperienceOptions(data)
      ),
    []
  );

  function setSelectedYearsOfExperienceOptions(list) {
    setSearchObject({ ...searchObject, yearsOfExperienceOptions: list });
  }
  
  return (
    <fieldset>
      <legend>{t("Years of Experience")}</legend>
      <DropDownMultiCheck
        dataList={yearsOfExperienceOptions}
        selecteds={searchObject.yearsOfExperienceOptions}
        setSelecteds={setSelectedYearsOfExperienceOptions}
      />
    </fieldset>
  );
}
